/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { ICON_MORE_HORIZ } from '../../Icons';
import { ButtonProps } from '../Button';
import { Dropdown, DropdownMenuProps, DropdownSectionData } from '../Dropdown';
import { ActionMenuProps, actionMenuDefaults } from './ActionMenu.props';

/**
 * SDS ActionMenu component.
 */
export const ActionMenu = (props: ActionMenuProps): JSX.Element => {
  const {
    buttonLabel,
    classes,
    dropdownPosition,
    itemList,
    sectionKey,
    buttonFormat,
    buttonTheme,
    buttonCustomContent,
    ...rest
  } = {
    ...actionMenuDefaults,
    ...props,
  };

  const sections: Array<DropdownSectionData> = [
    {
      items: itemList,
      key: sectionKey,
    },
  ];

  const buttonProps: ButtonProps = {
    customContent: buttonCustomContent,
    format: buttonFormat,
    icon: ICON_MORE_HORIZ,
    label: buttonLabel,
    theme: buttonTheme,
    tooltip: props.tooltip,
  };

  const dropdownProps: DropdownMenuProps = {
    buttonProps: buttonProps,
    classes: classes,
    dropdownPosition: dropdownPosition,
    sections: sections,
  };

  if (itemList.length > 0) {
    return <Dropdown {...dropdownProps} {...rest} />;
  }

  return <></>;
};
